import React, { useEffect, useState } from 'react';
import TablaPartidosPersona from './TablaPartidosPersona.js';
import TablaGolesPersona from './TablaGolesPersona.js';
import TablaExpulsionesPersona from './TablaExpulsionesPersona.js';
import * as ModoPersona from '../constantes/ModoPersona.js';
import BotoneraFiltros from '../UI/BotoneraFiltros.js';
import CuadroDatos from '../UI/CuadroDatos.js';
import useGetURL from '../../hooks/useGetURL.js';

const Boton = {
  PARTIDOS_ARBITRO: 'pa',
  PARTIDOS_JUGADOR: 'pj',
  PARTIDOS_TECNICO: 'pt',
  GOLES_CONVERTIDOS: 'gc',
  GOLES_RECIBIDOS: 'gr',
  EXPULSIONES: 'ex',
};

const EstadisticasPersona = (props) => {
  const [totales, setTotales] = useState(null);
  const [botonPresionado, setBotonPresionado] = useState(null);
  const { isCargando, erroresGet, fetchData, resetErroresGet } = useGetURL();
  const persona = props.persona;
  const idPersona = props.persona && props.persona.id;

  useEffect(() => {
    resetErroresGet();
  }, [resetErroresGet]);

  useEffect(() => {
    if (idPersona === null) {
      setTotales(null);
    } else {
      fetchData('personas/' + idPersona + '/totales', setTotales);
    }
  }, [fetchData, idPersona]);

  const onClickBoton = (boton) => {
    // Toggle: si es el mismo botón, desmarcar; si es otro, seleccionar
    if (botonPresionado === boton) {
      setBotonPresionado(null);
    } else {
      setBotonPresionado(boton);
    }
  };

  let tabla = '';
  switch (botonPresionado) {
    case Boton.PARTIDOS_ARBITRO: {
      tabla = <TablaPartidosPersona persona={persona} modo={ModoPersona.ARBITRO} />;
      break;
    }
    case Boton.PARTIDOS_JUGADOR: {
      tabla = <TablaPartidosPersona persona={persona} modo={ModoPersona.JUGADOR} />;
      break;
    }
    case Boton.PARTIDOS_TECNICO: {
      tabla = <TablaPartidosPersona persona={persona} modo={ModoPersona.TECNICO} />;
      break;
    }
    case Boton.GOLES_CONVERTIDOS:
    case Boton.GOLES_RECIBIDOS: {
      tabla = <TablaGolesPersona persona={persona} />;
      break;
    }
    case Boton.EXPULSIONES: {
      tabla = <TablaExpulsionesPersona persona={persona} />;
      break;
    }
    default:
  }

  return (
    <CuadroDatos titulo="Estadísticas" isCargando={isCargando} errores={erroresGet}>
      {totales && !isCargando && (
        <React.Fragment>
          {(() => {
            // Construir array de filtros dinámicamente
            const filtros = [];

            if (persona.esArbitro) {
              filtros.push({
                codigo: Boton.PARTIDOS_ARBITRO,
                descripcion: `Partidos Arbitro: ${totales.partidosArbitro}`,
              });
            }

            if (persona.esJugador) {
              filtros.push({
                codigo: Boton.PARTIDOS_JUGADOR,
                descripcion: `Partidos Jugador: ${totales.partidosJugador}`,
              });
            }

            if (persona.esTecnico) {
              filtros.push({
                codigo: Boton.PARTIDOS_TECNICO,
                descripcion: `Partidos Técnico: ${totales.partidosTecnico}`,
              });
            }

            if (persona.esJugador) {
              filtros.push({
                codigo: Boton.GOLES_CONVERTIDOS,
                descripcion: `Goles: ${totales.golesConvertidos}`,
              });
            }

            if (persona.esJugador && totales.golesRecibidos > 0) {
              filtros.push({
                codigo: Boton.GOLES_RECIBIDOS,
                descripcion: `Goles Recibidos: ${totales.golesRecibidos}`,
              });
            }

            if (persona.esJugador || persona.esTecnico) {
              filtros.push({
                codigo: Boton.EXPULSIONES,
                descripcion: `Expulsiones: ${totales.expulsiones}`,
              });
            }

            return (
              <BotoneraFiltros
                filtros={filtros}
                selected={botonPresionado}
                onFiltroElegido={onClickBoton}
              />
            );
          })()}
          {tabla}
        </React.Fragment>
      )}
    </CuadroDatos>
  );
};

export default EstadisticasPersona;
